
import "./App.css";
import React, { useState, useEffect } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Login from "./components/login";
import SignUp from "./components/signUp";
import OTPVerification from "./components/otpVerification";
import ForgotPassword from "./components/forgotPassword";
import ResetPassword from "./components/resetPassword";
import { useCookies } from 'react-cookie';
import InformationExtraction from "./pages/InformationExtraction";
import MultiSearch from "./pages/mmsSearch";
import MultiFileUpload from "./pages/mmsFileUpload"
import DvdBiBot from "./pages/DvdBiBot";
import EnterpriseSearch from "./pages/EnterpriseSearch";
import EnterpriseSearchMobile from "./pages/EnterpriseSearchMobile";
import Ocr from "./pages/ocr";
import EnterpriseFileUpload from "./pages/EnterpriseFileUpload";

const App = () => {
  const [cookies] = useCookies(['jwtToken']);
  const jwtToken = cookies['jwtToken'];


  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Function to set authentication status
  const setAuthenticationStatus = (status) => {
    setIsAuthenticated(status);
  };

  // Check if the user is authenticated
  useEffect(() => {
    if (jwtToken) {
      setAuthenticationStatus(true);
    } else {
      setAuthenticationStatus(false);
    }
  }, [jwtToken, cookies]);

  return (

    <Layout isAuthenticated={isAuthenticated}>
      <Routes>
        {!isAuthenticated ? (
          <>
            <Route path="/login" element={<Login setAuthenticationStatus={setAuthenticationStatus} />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/otp-verification" element={<OTPVerification />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </>
        ) : null}

        {isAuthenticated ? (
          <>
            <Route path="/information-extraction" element={<InformationExtraction />} />
            <Route path="/" element={<InformationExtraction />} />
            <Route path="/search" element={<MultiSearch/>} />
            <Route path="/multifileupload" element={<MultiFileUpload />} />
            <Route path="/bi-assistant" element={<DvdBiBot />} />
            <Route path="/enterprise-search" element={<EnterpriseSearch />} />
            <Route path="/enterprise-search-mobile" element={<EnterpriseSearchMobile />} />
            <Route path="/ocr" element={<Ocr/>} />
            {/* <Route path="/" element={<EnterpriseSearch />} /> */}
            <Route path="/Enterprise-fileupload" element={<EnterpriseFileUpload />} />
          </>
        ) : null}

        {isAuthenticated ? <Route path="/*" element={<Navigate to="/" />} /> : null}
        {!isAuthenticated ? <Route path="/*" element={<Navigate to="/login" />} /> : null}
      </Routes>
    </Layout>


  );
};

export default App;
